//import _ from 'lodash'
import { ActionTypes } from '../actions'

const {
  FETCH_INITIAL_DATA_RECEIVED,
  SET_MONTH,
  SET_STATISTICS,
  SET_PUBLIC_HOLIDAYS,
} = ActionTypes

const accounting = (state = {}, action) => {
  switch (action.type) {
    case FETCH_INITIAL_DATA_RECEIVED:
      return {
        ...state,
        ...action.data,
      }
    case SET_MONTH:
      return {
        ...state,
        month: action.month,
      }
    case SET_STATISTICS:
      return {
        ...state,
        statistics: action.statistics,
      }
    case SET_PUBLIC_HOLIDAYS:
      return {
        ...state,
        public_holidays: action.public_holidays,
      }
    default:
      return state
  }
}

export default accounting
